export class HhsgSharedStuderSupportContact {
	id: number;
	organizationId: number;
	name: string;
	email: string;
	phone1: string;
	phone2: string;
	fax: string;
	mailingAddress: string;
	website: string;
	isDeleted: boolean;
	hapApplicationIds: number[] = [];
}
